<template>
  <div class="animated fadeIn">
    <default-heading class="mt-3">DTE Modus XML API</default-heading>
    <div class="my-4"></div>
    <p>
      Down to Earth Labs has adopted and implemented the <a target="_blank" href="https://modusproject.atlassian.net/wiki/display/PD/Modus+Project+Charter">Modus Agronomic Testing Lab Transfer Standard</a>. Test results can now be converted to the standardized Modus XML format. As an additional value-add we have supplied a RESTful API to allow authenticated 3rd party software to pull your results automatically.
    </p>
    <div class="display-4 font-3xl mb-2">API User ID</div>
    <p>The 36 character token below is your API user ID. This token is a unique link to your DTE account.</p>
    <b-input-group class="border border-white mb-4" v-if="api_user_id">
      <b-form-input
        disabled
        type="text"
        class="form-control"
        placeholder="API User ID"
        v-model="api_user_id"
      />
    </b-input-group>
    <div class="display-4 font-3xl mb-2">API Access Key</div>
    <p>The 128 character token below is your API Access Key. This token acts as a password to your DTE account when accessed via the API.</p>
    <b-input-group class="border border-white mb-4" v-if="api_access_key">
      <b-form-input
        disabled
        type="text"
        class="form-control"
        placeholder="API Access Key"
        v-model="api_access_key"
      />
    </b-input-group>
    <div class="display-4 font-3xl mb-2">API Developer Keys</div>
    <p>Developer keys are required for 3rd party applications to connect to the API using your authentication credentials (use ID and access key above). Dev keys can be quickly created or revoked without having to completely renew your authentication information.</p>
    <b-table
      bordered
      striped
      hover
      small
      :items="api_developer_keys"
      :fields="api_developer_fields"
    >
      <template slot="date" slot-scope="data">
        {{ data.item.date | moment("dddd, MMMM Do YYYY") }}
      </template>
      <template slot="actions">
        <b-button size="sm" variant="danger"><i class="fal fa-trash"></i></b-button>
      </template>
    </b-table>
    <div class="display-4 font-3xl mb-2">API Guide</div>
    <p><a target="_blank" href="https://downtoearthlabs.com/userfile/file/DTE_MODUS_Web_Service_v1.pdf">Click here</a> to read the documentation. The documentation describes the interaction between 3rd party applications and the Down To Earth Labs MODUS web service.</p>
  </div>
</template>

<script>

  import DefaultHeading from "../../components/shared/DefaultHeading";

  export default {
    components: {DefaultHeading},
    name: 'ApiIndex',
    data() {
      return {
        api_user_id: null,
        api_access_key: null,
        api_developer_fields: [
          'name',
          'key',
          'date',
          { key: 'actions', label: 'Actions' }
        ],
        api_developer_keys: [],
      }
    },
    methods: {

    },
    mounted() {
      this.api_user_id = this.$uuid.v1();
      this.api_access_key = this.$uuid.v1();
      this.api_developer_keys = [
        {name: 'Test1', key: this.$uuid.v1(), date: this.$moment()},
        {name: 'Test2', key: this.$uuid.v1(), date: this.$moment()},
        {name: 'Test3', key: this.$uuid.v1(), date: this.$moment()}
      ];
    }
  }
</script>
